import React from 'react'
import { TransformedResolvedPerson } from '../../../helixSearch/HelixSearchTypes'
import { MapExtra } from '../../../utils/MapExtra'
import { CompanyDto } from '../../../api/company/models/CompanyDto'
import { formatDuration } from '../../../utils/dateUtils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'

interface Props {
    connections?: TransformedResolvedPerson
    companiesById: MapExtra<string, CompanyDto>
    title?: string
}

export default function CandidateConnectionsSingleSeed({
    connections,
    companiesById,
    title = 'You worked together at',
}: Props): React.JSX.Element | null {
    if (!connections?.companies?.length) return null

    return (
        <div className="rounded-lg border-ctxt-blue bg-ctxt-blue/10 text-gray-800 p-3">
            <div className="text-sm font-bold text-gray-900 mb-2">{title}</div>
            <div className="space-y-2">
                {connections.companies.map((company) => {
                    const companyDetails = companiesById.get(company.companyId)
                    if (!companyDetails || company.connections.length === 0)
                        return null

                    const best = company.connections.reduce((a, b) =>
                        b.cumulativeOverlapMs > a.cumulativeOverlapMs ? b : a,
                    )

                    const { fromTo, duration } = formatDuration(
                        best.overallStart,
                        best.overallEnd,
                    )

                    return (
                        <div
                            key={company.companyId}
                            className="flex items-start gap-2 mb-2 ml-1 text-sm"
                        >
                            <FontAwesomeIcon
                                icon={faBuilding}
                                className="text-ctxt-blue mt-1"
                            />
                            <div>
                                <span className="font-bold text-ctxt-blue">
                                    {companyDetails.name}
                                </span>
                                <span className="text-gray-500 ml-1 italic">
                                    · {fromTo} · {duration}
                                </span>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
